import { ActivityLogParser } from '@/parsers/activityLog'

export class ContactActivityLogParser extends ActivityLogParser {
    static attributeDataTypes = {
        'consultants.id': 'consultants',
        'customer_since': 'date',
        'customer_until': 'date',
        'correspondenceLanguage.id': 'correspondenceLanguage',
        'nationality.id': 'country',
        'driving_licence_since': 'date',
    }
}
